/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FapSummaryDto } from './FapSummaryDto';
export type AdviserResponseDto = {
    /**
     * Unique user identifier (UUID)
     */
    id: string;
    /**
     * Auth0 user identifier
     */
    authId: string;
    /**
     * User email address
     */
    emailAddress: string;
    /**
     * Whether the email address has been verified
     */
    emailVerified: boolean;
    /**
     * User first name
     */
    firstName?: string | null;
    /**
     * User last name
     */
    lastName?: string | null;
    /**
     * Whether multi-factor authentication is enabled
     */
    mfaEnabled: boolean;
    /**
     * User account status
     */
    status: AdviserResponseDto.status;
    /**
     * User roles
     */
    roles: Array<'SUPER_ADMIN' | 'BUSINESS_ADMIN' | 'FINANCE_ADMIN' | 'ADVISER'>;
    /**
     * UUID of the Adviser entity this user is associated with
     */
    adviserId?: string | null;
    /**
     * UUID of the FAP (Financial Advice Provider) this user belongs to
     */
    fapId?: string | null;
    /**
     * FAP details if associated
     */
    fap?: FapSummaryDto | null;
    /**
     * Adviser FSPR number (from linked Adviser entity)
     */
    fsprNumber?: string | null;
    /**
     * Adviser role classification
     */
    adviserRole?: AdviserResponseDto.adviserRole | null;
    /**
     * Adviser commission percentage
     */
    commissionPercentage?: number | null;
    /**
     * Adviser override percentage
     */
    overridePercentage?: number | null;
    /**
     * Override recipient name
     */
    overrideName?: string | null;
    /**
     * Adviser broker fee percentage
     */
    brokerFeePercentage?: number | null;
    /**
     * Quoting adviser new business commission percentage
     */
    qaCommissionPercentage?: number | null;
    /**
     * Quoting adviser renewal commission percentage
     */
    qaRenewalCommissionPercentage?: number | null;
    /**
     * Last login timestamp
     */
    lastLogin?: string | null;
    /**
     * User creation timestamp
     */
    createdAt: string;
    /**
     * User last update timestamp
     */
    updatedAt: string;
};
export namespace AdviserResponseDto {
    /**
     * User account status
     */
    export enum status {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
    /**
     * Adviser role classification
     */
    export enum adviserRole {
        AUTHORISED_REP = 'AUTHORISED_REP',
        QUOTING_ADVISER = 'QUOTING_ADVISER',
        INTERNAL_ADVISER = 'INTERNAL_ADVISER',
    }
}

